import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import profile from "./profile";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import Modal from "react-responsive-modal";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class help_center extends Component{

    constructor(props, context) {
        super(props, context);

        this.state = {
            windowHeight: 0,
            nosessionredirect:false,
            categoryList: []
        };
        this.updateState = this.updateState.bind(this);
    };

    updateState(e) {
        this.setState({});

    }

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

    }

    componentDidMount(){

        document.title = "Help Center - " + localStorage.getItem("store_name") + " - Tria Commerce";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }



        var height = $(window).height();
        this.setState({windowHeight: height});
    }

    render(){

        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        return(
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/myaccount'}></Link>
                        <h2 className="text-center">{t('help_center')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35  bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('assistance')}</h2>
                                </div>
                                <div className="header-content help_content">
                                    <p className="font-family-bold">{t('email')}: {localStorage.getItem("store_email")} </p>
                                    <p>{t('phone')}: {localStorage.getItem("store_phone")}</p>
                                    <p>{localStorage.getItem("store_address")}</p>
                                    <p>{localStorage.getItem("store_city")}, {localStorage.getItem("store_state")} {localStorage.getItem("store_zip")}</p>
                                </div>

                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(help_center));


// WEBPACK FOOTER //
// ./src/view_components/help_center.js